import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { getDocumentName, graphql } from '@e-socna/data-layer';
import { EMPTY_OBJECT } from '@e-socna/empty';

import { AuthenticationContextProvider_AuthenticatedUser_QueryDocument } from '../contexts/AuthenticationContext';

import { useGraphQLMutation } from './useGraphQLMutation.hook';

export const UserMenu_Logout_Mutation = graphql(`
  mutation UserMenu_Logout {
    logout {
      loggedOut
    }
  }
`);

export const useLogout = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const { mutate: logoutMutation } = useGraphQLMutation(
    UserMenu_Logout_Mutation,
  );

  return useCallback(() => {
    logoutMutation(EMPTY_OBJECT, {
      onSuccess: () => {
        queryClient.setQueryData(
          [
            getDocumentName(
              AuthenticationContextProvider_AuthenticatedUser_QueryDocument,
            ),
          ],
          { mustLogout: true },
        );
        enqueueSnackbar('Vous êtes maintenant déconnecté(e). À bientôt !');
      },
    });
  }, [enqueueSnackbar, logoutMutation, queryClient]);
};
